import React, { Component } from 'react'
import { includes, range, size } from 'lodash'
import BundleScanner from '../components/BundleScanner'
import { CasePickerItemStatus } from '../components/CasePickerItem'
import { InputTextRef } from '../components/InputText'

interface PackTraceCreateBundlesProps {
  bundles: number
  scannedPositions: number[]
  scannedCodes: string[]
  inputRefs: InputTextRef[]
  onScan: (position: number, scan: string) => void
  onScanError : boolean[]
  onScanErrorCallback:() => void
}

export default class PackTraceCreateBundles
  extends Component<PackTraceCreateBundlesProps> {
  isScanned (position: number) {
    return includes(this.props.scannedPositions, position)
  }

  isAvailable (position: number) {
    const currentScanned = size(this.props.scannedPositions)
    const nextScannable = (currentScanned + 1)
    return nextScannable === position
  }

  status (position: number): CasePickerItemStatus {
    const isSelected = this.isScanned(position)
    const isAvailable = this.isAvailable(position)
    return isSelected
      ? 'selected'
      : isAvailable
        ? 'available'
        : 'unavailable'
  }

  inputRef (position: number) {
    const inputRefIndex = (position - 1)
    return this.props.inputRefs[inputRefIndex]
  }

  scannable (position: number) {
    const inputRef = this.inputRef(position)
    return (
      <BundleScanner
        className="m-3"
        size="large"
        status={this.status(position)}
        position={position}
        onBundleScan={this.props.onScan}
        scannedCodes={this.props.scannedCodes}
        inputRef={inputRef}
        key={position}
        onScanError={this.props.onScanError[position]}
        onScanErrorCallback={this.props.onScanErrorCallback} />
    )
  }

  get scannables () {
    const positions = range(1, this.props.bundles + 1)
    return positions.map(position => {
      return this.scannable(position)
    })
  }

  render () {
    return (
      <div className="block">
        {this.scannables}
      </div>
    )
  }
}
